/*
 * @Descripttion:
 * @version:
 * @Author: 陈宇鹏
 * @Date: 2021-07-14 17:15:09
 * @LastEditors: 陈宇鹏
 * @LastEditTime: 2021-07-22 14:22:27
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Cookies from 'js-cookie'
import {
  openIdlogin,
  toLoginView,
  isWeiXin,
  toJobList,
} from '@/utils/openIdLogin'
//页面相关路由
import Main from './routers/main'
import Recommend from './routers/recommend'
import About from './routers/about'
import ReceivingOrders from './routers/receivingOrders'
import ReceivingOrderList from './routers/receivingOrderList'
import PositionDetail from './routers/positionDetail'
import ActingOperationDaily from './routers/actingOperationDaily'
import AgentOperationAfrim from './routers/agentOperationAfrim'
import Collection from './routers/collection'
import HistoryBrows from './routers/historyBrows'
import Login from './routers/login'
import CommunicateRecord from './routers/communicateRecord'
import AskQuestions from './routers/askQuestions'
import RecommendReport from './routers/recommendReport'
import TweetList from './routers/tweetList'
import TweetRecommend from './routers/tweetRecommend'
import TalentFind from './routers/talentFind'
import CandidateNews from './routers/candidateNews'
import TalentDetail from './routers/talentDetail'
import TalentRecom from './routers/talentRecom'
import SuccPanel from './routers/succPanel'

import RealNme from './routers/realName'

import Activity from './routers/activity'
import PrivacyPhone from './routers/privacyPhone'
import NoPanel from './routers/noPanel'
import CompanyEntry from './routers/companyEntry'
import companyApply from './routers/companyApply'
import IsEnterprise from './routers/IsEnterprise'
import readfilder from './routers/readfilder'
import candidateAuth from './routers/candidateAuth'
import collectionRecruitInfo from './routers/collectionRecruitInfo'
import BillConfirm from './routers/billConfirm'
import talentSquareDetail from './routers/talentSquareDetail'
import talentSquareList from './routers/talentSquareList'
import talentSquareRegister from './routers/talentSquareRegister'
import realNameFace from './routers/realNameFace'
import fileCheck from './routers/fileCheck'

Vue.use(VueRouter)

const routes = [
  RealNme,
  Recommend,
  Main,
  About,
  ReceivingOrders,
  ReceivingOrderList,
  PositionDetail,
  ActingOperationDaily,
  AgentOperationAfrim,
  Collection,
  HistoryBrows,
  Login,
  CommunicateRecord,
  AskQuestions,
  RecommendReport,
  TweetList,
  TweetRecommend,
  TalentFind,
  CandidateNews,
  TalentDetail,
  TalentRecom,
  SuccPanel,
  Activity,
  PrivacyPhone,
  CompanyEntry,
  IsEnterprise,
  companyApply,
  NoPanel,
  readfilder,
  collectionRecruitInfo,
  candidateAuth,
  talentSquareDetail,
  talentSquareList,
  talentSquareRegister,
  realNameFace,
  fileCheck,
  ...BillConfirm,
  {
    path: '/',
    redirect: '/main',
  },
]
//解决路由重复问题
// const originalPush = VueRouter.prototype.push
//    VueRouter.prototype.push = function push(location) {
//    return originalPush.call(this, location).catch(err => err)
// }
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})
router.beforeEach((to, from, next) => {
  // if(to&&to.path&&to.path.includes('/candidateAuth')){
  //     window.document.title='人才授权';
  //     next();
  //     return
  // }
  let loginInfo = Cookies.get('loginInfo')
    ? JSON.parse(Cookies.get('loginInfo'))
    : ''
  let obj = toLoginView(to)
  let isList = toJobList(to, loginInfo)
  if (!loginInfo) {
    let data = {}
    if (isWeiXin() && to.path.includes('candidateAuth') == -1) {
      data.cb = (data) => {
        if (isList) {
          next({ name: 'position' }) //未登录回到职位列表页
        } else {
          if (obj && obj.query) {
            //未登录回到登录页
            let name = 'login'
            if (data == 3) {
              name = to.name
            }
            next({ name: name, query: obj.query })
          } else {
            //未登录回到当前页
            next()
          }
        }
      }
      openIdlogin(data)
    } else {
      if (isList) {
        next({ name: 'position' })
      } else {
        if (obj && obj.query) {
          let name = 'login'
          next({ name: name, query: obj.query })
        } else {
          next()
        }
      }
    }
  } else {
    if (isList) {
      next({ name: 'position' })
    } else {
      next()
    }
  }
})
export default router
